module.exports = __webpack_public_path__ + "img/cropped-rylan-hill-pf-eZzTvVzk-unsplash-compressed-large.1def4aed.webp";